const moduleName = 'messages';

export function messages() {
    document.querySelectorAll('.js-close-message').forEach((btn) => {
        btn.addEventListener('click', function (){
            btn.closest('.popup-message').classList.remove('_visible');
        });
    });
}
